export const width = () => {
  let w = window.innerWidth;

  // console.log("Largura da tela(innerWidth):", w)
  if (w < 800) return "mobile";

  return "desktop";
};

export const generateId = function () {
  return '_' + Math.random().toString(36).substr(2, 9);
};

export const SimNao = [{ 'value': 'SIM', 'label': 'Sim' }, { 'value': 'NAO', 'label': 'Não' }]

export const posicoes = [
  { posicao: 'VALIDO', descricao: 'Valido' },
  { posicao: 'INATIVO', descricao: 'Inativo' },
  { posicao: 'VENCENDO', descricao: 'Vencendo' },
  { posicao: 'VENCIDO', descricao: 'Vencido' },
]